import PharmacySalesCharts from './component/PharmacySalesChart'
const PharmacySales = () => {
  return (
    <>
      <PharmacySalesCharts />
    </>
  )
}

export {PharmacySales}
